import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AUTH_API } from '@dges/modules/auth/domain';
import { FirebaseAuthService } from './firebase-auth.service';

export function provideAuthFirebaseApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_API, useExisting: FirebaseAuthService },
  ]);
}
